<template lang="pug">
  div
    v-input(
      hide-details,
      prepend-icon="far fa-calendar-alt",
    )
      DatePicker(
        range,
        :disabled-date="disabledDates",
        :editable="false"
        :format="format",
        :placeholder="placeholder",
        :shortcuts="shortcuts",
        :type="type",
        :value="value",
        @input="$emit('update:value', $event)",
      )
        template(v-slot:icon-clear)
          i.fas.fa-times-circle
</template>

<script>
import {
  isAfterToday,
  isBeforeDate,
  subDurationFromToday,
  subMonthsFromDate,
} from '@/utils/time';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: { DatePicker },
  props: {
    placeholder: {
      type: String,
      default: 'Date',
    },

    value: {
      validator: prop => ['object', 'array', 'undefined'].includes(typeof prop),
      required: true,
    },

    hideShortCuts: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'date',
    },

    minDate: {
      validator: prop =>
        ['string', 'date', 'object', 'undefined'].includes(typeof prop),
      default: undefined,
    },

    format: {
      type: String,
      default: 'DD/MM/YYYY',
    },
  },

  data: () => ({
    date: null,
  }),

  computed: {
    shortcuts() {
      if (this.hideShortCuts) {
        return [];
      }

      return [
        {
          text: this.$t('component.rangePicker.today'),
          onClick: () => [new Date(), new Date()],
        },
        {
          text: this.$t('component.rangePicker.past3Days'),
          onClick: () => [subDurationFromToday({ days: 3 }), new Date()],
        },
        {
          text: this.$t('component.rangePicker.past1Week'),
          onClick: () => [subDurationFromToday({ weeks: 1 }), new Date()],
        },
        {
          text: this.$t('component.rangePicker.past1Month'),
          onClick: () => [subDurationFromToday({ months: 1 }), new Date()],
        },
        {
          text: this.$t('component.rangePicker.past3Months'),
          onClick: () => [subDurationFromToday({ months: 3 }), new Date()],
        },
      ];
    },
  },

  methods: {
    isAfterToday,

    disabledDates(date) {
      if (this.minDate) {
        return (
          isBeforeDate(date, subMonthsFromDate(this.minDate, 1)) ||
          isAfterToday(date)
        );
      }

      return isAfterToday(date);
    },

    updateDate(dates) {
      const [start, end] = dates;
      this.$emit('update:value', {
        start,
        end: new Date(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          23,
          59,
          59,
          999,
        ),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .mx-datepicker {
  max-width: 230px;

  .mx-icon-calendar {
    display: none;
  }

  .mx-icon-clear {
    font-size: 24px;
    right: 4px;
    &:hover {
      color: rgba(0, 0, 0, 0.5);
    }
  }

  &:hover {
    .mx-input {
      border-bottom: 1px solid rgba(0, 0, 0);
    }
  }

  .mx-input {
    border: 0px;
    box-shadow: 0 0 black;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    border-radius: 0;
    font-size: 16px;

    &:focus {
      border-bottom: 1px solid rgba(0, 0, 0);
    }
    // padding: 6px 6px 6px 48px;
  }
}
</style>
